import {ConfigService} from '../config/config.service'
import {Logger} from '../logging/logger.types'
import {LocalStorageService} from '../storage/local-storage.service'
import {AuthStatusService} from './auth-status.service'
import {ErrorMonitor} from '../error/error-monitoring.types'
import {isPlatformBrowser} from '@angular/common'
import {GraphqlLinkController} from '../graphql/graphql-link.controller'
import {PLATFORM_ID, Provider} from '@angular/core'
import {AuthService} from './auth.service'
import {AuthBrowserService} from './auth.browser.service'
import {AuthServerService} from './auth.server.service'

export const provideAuth: () => Provider[] = () => [
  {
    provide: AuthService,
    useFactory: (
      configService: ConfigService,
      logger: Logger,
      localStorageService: LocalStorageService,
      authStatusService: AuthStatusService,
      errorMonitor: ErrorMonitor,
      graphqlLinkController: GraphqlLinkController,
      platformId: Record<string, unknown>,
    ) => {
      if (isPlatformBrowser(platformId)) {
        return new AuthBrowserService(
          configService,
          logger,
          localStorageService,
          authStatusService,
          errorMonitor,
          graphqlLinkController,
        )
      }
      return new AuthServerService(authStatusService)
    },
    deps: [
      ConfigService,
      Logger,
      LocalStorageService,
      AuthStatusService,
      ErrorMonitor,
      GraphqlLinkController,
      PLATFORM_ID,
    ],
  },
]
